import React from "react";
import { Box } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import ProjectSelfEvaluationIndicatorManager from "@/components/indicators/ProjectSelfEvaluationIndicatorManager";

const ProjectSelfEvaluationIndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <ProjectSelfEvaluationIndicatorManager />
      </Box>
    </Box>
  );
};

export default ProjectSelfEvaluationIndicatorPage;
